<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data().title" [separator]="false" />
  </ng-container>

  <ng-container body>
    <email-margin [height]="20" />
    <email-text [contents]="data().p1_html" presetName="paragraph" />
    <email-margin [height]="28" />
    <email-text [contents]="data().p2_html" presetName="paragraph" />
    <email-text [contents]="data().p3_html" presetName="paragraph" />
    <email-margin [height]="28" />
    <email-button [href]="data().button_link" [label]="data().button_text" theme="primary" />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data().footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data().footer.label"
      [href]="data().footer.href"
      [target]="data().footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
